/*
 * mutation-types 在此配置mutations的type
 * @Author: ice
 * @Date: 2017-07-24 19:21:07
 * @Last Modified by: ice
 * @Last Modified time: 2017-11-24 16:49:27
 */
// 设置用户信息
export const SET_USER_INFO = 'SET_USER_INFO';
// 设置登出
export const SET_LOG_OUT = 'SET_LOG_OUT';


// WEBPACK FOOTER //
// ./src/store/types/mutation-types.js